import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { logger } from '~/classes/Logger';
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        // Cập nhật state để render UI thay thế
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        var _a, _b;
        // Ghi log lỗi vào console hoặc dịch vụ báo cáo lỗi
        logger.error('Lỗi được bắt bởi ErrorBoundary:', error, errorInfo);
        (_b = (_a = this.props).onError) === null || _b === void 0 ? void 0 : _b.call(_a, error, errorInfo);
        // Tùy chọn: Reset trạng thái lỗi sau một khoảng thời gian để thử phục hồi
        if (this.props.resetAfterError) {
            setTimeout(() => {
                this.setState({ hasError: false, error: null });
            }, typeof this.props.resetAfterError === 'number' ? this.props.resetAfterError : 5000);
        }
    }
    render() {
        var _a;
        if (this.state.hasError) {
            // Render UI thay thế khi có lỗi
            return typeof this.props.fallback === 'function'
                ? this.props.fallback(this.state.error)
                : this.props.fallback || (_jsxs("div", { className: "error-container", children: [_jsx("h3", { children: "\u0110\u00E3 x\u1EA3y ra l\u1ED7i khi t\u1EA3i th\u00E0nh ph\u1EA7n." }), _jsx("p", { className: "error-details", children: (_a = this.state.error) === null || _a === void 0 ? void 0 : _a.message }), this.props.showResetButton && (_jsx("button", { onClick: () => this.setState({ hasError: false, error: null }), children: "Th\u1EED l\u1EA1i" }))] }));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
